export enum CardStatus {
  inactive = 'INACTIVE',
  active = 'ACTIVE',
  rejected = 'REJECTED',
  expired = 'EXPIRED',
}
